import { render } from "./magento.vue?vue&type=template&id=210b0d1d&scoped=true"
import script from "./magento.vue?vue&type=script&lang=js"
export * from "./magento.vue?vue&type=script&lang=js"

import "./magento.vue?vue&type=style&index=0&id=210b0d1d&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210b0d1d"]])

export default __exports__